export const tr = {
    'accept-additions-confirm-groups':
        'Moderasyon olmadan seçilen gruplara bağlı olan tüm netleştirmeleri kabul etmek istediğinize emin misiniz?',
    'accept-additions-single-confirm-groups':
        'Moderasyon olmadan {name} grubuna bağlı olan tüm netleştirmeleri KABUL etmek istediğinize emin misiniz?',
    'accept-moderations-confirm-groups': 'Moderasyon olmadan seçilen grupları KABUL etmek istediğinize emin misiniz?',
    'accept-moderations-single-confirm-groups':
        'Moderasyon olmadan {name} grubunu KABUL etmek istediğinize emin misiniz?',
    'actions-title': 'İşlemler',
    addToFavorites: 'En önemlilere ekle',
    admSendMD: 'Yeniden moderasyon',
    'all-banners-not-saved': 'Reklamlar kaydedilmedi',
    'all-banners-saved': 'Tüm reklamlar başarıyla kaydedildi',
    archive: 'Arşivle',
    'archive-success': 'Kampanyalar arşive kaldırıldı',
    archiveBanner: 'Arşivle',
    'banner-archive-success': "Seçilen tüm banner'lar arşive eklendi",
    'banner-archive-success-none': "Banner'lar arşive eklenemedi",
    'banner-archive-success-some': {
        one: '{count} / {allCount} banner arşive eklendi.',
        some: '{count} / {allCount} banner arşive eklendi.',
        many: '{count} / {allCount} banner arşive eklendi.',
        none: '{count} / {allCount} banner arşive eklendi.'
    },
    'banner-delete-success': "Seçilen tüm banner'lar silindi",
    'banner-delete-success-none': "Banner'lar silinemedi",
    'banner-delete-success-some': {
        one: '{count} / {allCount} banner silindi.',
        some: '{count} / {allCount} banner silindi.',
        many: '{count} / {allCount} banner silindi.',
        none: '{count} / {allCount} banner silindi.'
    },
    'banner-resume-success': "Banner'lar için gösterimler devam ediyor",
    'banner-resume-success-none': 'Banner gösterimleri devam edemedi',
    'banner-resume-success-some': {
        one: '{count} / {allCount} banner için gösterimler devam ediyor.',
        some: '{count} / {allCount} banner için gösterimler devam ediyor.',
        many: '{count} / {allCount} banner için gösterimler devam ediyor.',
        none: '{count} / {allCount} banner için gösterimler devam ediyor.'
    },
    'banner-stop-success': "Banner'lar durduruldu",
    'banner-stop-success-none': 'Banner gösterimleri durdurulamadı',
    'banner-stop-success-some': {
        one: '{count} / {allCount} banner durduruldu.',
        some: '{count} / {allCount} banner durduruldu.',
        many: '{count} / {allCount} banner durduruldu.',
        none: '{count} / {allCount} banner durduruldu.'
    },
    'banner-unarchive-success': "Seçilen tüm banner'lar arşivden çıkarıldı",
    'banner-unarchive-success-none': "Banner'lar arşivden çıkarılamadı",
    'banner-unarchive-success-some': {
        one: '{count} / {allCount} banner arşivden çıkarıldı.',
        some: '{count} / {allCount} banner arşivden çıkarıldı.',
        many: '{count} / {allCount} banner arşivden çıkarıldı.',
        none: '{count} / {allCount} banner arşivden çıkarıldı.'
    },
    'banners-fail-saved': {
        one: '{count} reklam kaydedilmedi',
        some: '{count} reklam kaydedilmedi',
        many: '{count} reklam kaydedilmedi',
        none: '{count} reklam kaydedilmedi'
    },
    'banners-organization-success-saved': {
        one: 'Kurum {count} reklamda değiştirildi',
        some: 'Kurumlar {count} reklamda değiştirildi',
        many: 'Kurumlar {count} reklamda değiştirildi',
        none: '{count} reklam kaydedildi'
    },
    'banners-success-saved': {
        one: '{count} reklamda fiyatlar değiştirildi',
        some: '{count} reklamda fiyatlar değiştirildi',
        many: '{count} reklamda fiyatlar değiştirildi',
        none: '{count} reklamda fiyatlar değiştirildi'
    },
    'banners-universal-with-yt-limit':
        'Sadece ilk {count} reklam seçildi; tek seferde daha fazlası değiştirilemez. Filtre uygulayarak listedeki reklam sayısını azaltabilirsiniz.',
    'campaigns-added-to-favorites': 'Kampanyalar, en önemli kampanyalara eklendi',
    'campaigns-delete-success': 'Kampanyalar silindi',
    'campaigns-removed-from-favorites': 'Kampanyalar, en önemli kampanyalardan kaldırıldı',
    'campaigns-universal-with-yt-limit':
        'Sadece ilk {count} kampanya seçildi; tek seferde daha fazlası değiştirilemez. Filtre uygulayarak listedeki kampanya sayısını azaltabilirsiniz.',
    'change-feed-filter-autobudget-priority': 'Önceliği değiştir',
    'change-feed-filter-rate': 'Teklif belirle',
    copy: 'Kopyala',
    'copy-disabled-info': 'Seçilen gruplar kopyalanamaz',
    'copy-disabled-info-cpm': "Sadece Medya banner'ı ve Video grupları seçin",
    'copy-error': 'Kopyalama talebi başarısız',
    'copy-success': 'Seçilen kampanyalar için kopyalama talep edildi',
    delete: 'Sil',
    'delete-confirm-banners': 'Seçilen reklamları silmek istediğinize emin misiniz?',
    'delete-confirm-campaigns': 'Seçilen kampanyaları silmek istediğinize emin misiniz?',
    'delete-confirm-feed-filters': 'Seçilen besleme filtrelerini silmek istediğinize emin misiniz?',
    'delete-confirm-groups': 'Seçilen grupları silmek istediğinize emin misiniz?',
    'delete-confirm-phrases': 'Seçilen sözcük gruplarını silmek istediğinize emin misiniz?',
    'delete-confirm-retargetings': 'Seçilen yeniden pazarlama koşullarını silmek istediğinize emin misiniz?',
    'delete-confirm-single-groups': '{name} grubunu silmek istediğinize emin misiniz?',
    'delete-feed-filters': 'Sil',
    'delete-phrases': 'Sil',
    'delete-retargetings': 'Sil',
    deleteBanners: 'Sil',
    'disable-feed-filters': 'Kapat',
    'disable-phrases': 'Durdur',
    'edit-feed-filters': 'Düzelt',
    'edit-organization': "Yandex.Rehber'den kurum bağlayın",
    editBanners: 'Düzelt',
    editBannersMass: 'Düzelt',
    editGroups: 'Düzelt',
    editPrices: 'Reklamdaki fiyatlar',
    'enable-feed-filters': 'Aç',
    'enable-phrases': 'Aç',
    'export-to-excel': "Excel'e aktar",
    'export-to-excel-with-banners': "Excel'e aktar (banner'lar ile)",
    'export-to-excel-without-banners': "Excel'e aktar (banner olmadan)",
    'feed-filters-change-priority-error-any': 'Besleme filtrelerinin öncelikleri güncellenemedi',
    'feed-filters-change-priority-error-one': 'Besleme filtresinin önceliği güncellenemedi',
    'feed-filters-change-priority-success-any': 'Seçilen tüm besleme filtrelerinin öncelikleri güncellendi',
    'feed-filters-change-priority-success-one': 'Besleme filtresi önceliği güncellendi',
    'feed-filters-change-priority-warning': {
        one: '{totalCount} besleme filtresinin {count} adedinin önceliği güncellendi',
        some: '{totalCount} besleme filtresinin {count} adedinin öncelikleri güncellendi',
        many: '{totalCount} besleme filtresinin {count} adedinin öncelikleri güncellendi',
        none: ''
    },
    'feed-filters-change-rate-error-any': 'Besleme filtresi teklifleri güncellenemedi',
    'feed-filters-change-rate-error-one': 'Besleme filtresi teklifi güncellenemedi',
    'feed-filters-change-rate-success-any': 'Seçilen tüm besleme filtrelerinin teklifleri güncellendi',
    'feed-filters-change-rate-success-one': 'Besleme filtresi teklifi güncellendi',
    'feed-filters-change-rate-warning': {
        one: '{totalCount} besleme filtresinin {count} adedinin teklifi güncellendi',
        some: '{totalCount} besleme filtresinin {count} adedinin teklifleri güncellendi',
        many: '{totalCount} besleme filtresinin {count} adedinin teklifleri güncellendi',
        none: ''
    },
    'feed-filters-delete-error-any': 'Besleme filtreleri silinemedi',
    'feed-filters-delete-error-one': 'Besleme filtresi silinemedi',
    'feed-filters-delete-success-any': 'Seçilen tüm besleme filtreleri silindi',
    'feed-filters-delete-success-one': 'Besleme filtresi silindi',
    'feed-filters-delete-warning': {
        one: '{count}/{totalCount} besleme filtresi silindi',
        some: '{count}/{totalCount} besleme filtresi silindi\r',
        many: '{count}/{totalCount} besleme filtresi silindi\r',
        none: ''
    },
    'feed-filters-disable-error-any': 'Besleme filtreleri kapatılamadı',
    'feed-filters-disable-error-one': 'Besleme filtresi kapatılamadı',
    'feed-filters-disable-success-any': 'Seçilen tüm besleme filtreleri kapatıldı',
    'feed-filters-disable-success-one': 'Besleme filtresi kapatıldı',
    'feed-filters-disable-warning': {
        one: '{count}/{totalCount} besleme filtresi kapatıldı\r',
        some: '{count}/{totalCount} besleme filtresi kapatıldı\r',
        many: '{count}/{totalCount} besleme filtresi kapatıldı\r',
        none: ''
    },
    'feed-filters-enable-error-any': 'Besleme filtreleri etkinleştirilemedi',
    'feed-filters-enable-error-one': 'Besleme filtresi etkinleştirilemedi',
    'feed-filters-enable-success-any': 'Seçilen tüm besleme filtreleri etkinleştirildi',
    'feed-filters-enable-success-one': 'Besleme filtresi etkinleştirildi',
    'feed-filters-enable-warning': {
        one: '{count}/{totalCount} besleme filtresi etkinleştirildi\r',
        some: '{count}/{totalCount} besleme filtresi etkinleştirildi\r',
        many: '{count}/{totalCount} besleme filtresi etkinleştirildi\r',
        none: ''
    },
    'feed-filters-universal-with-yt-limit':
        'Sadece ilk {count} filtre seçildi; tek seferde daha fazlası değiştirilemez. Filtre uygulayarak listedeki filtre sayısını azaltabilirsiniz.',
    goToBanners: 'Reklamlar',
    goToGroups: 'Gruplar',
    goToLogs: 'Değişiklikler listesi',
    goToMol: 'Rapor sihirbazına git',
    goToPhrases: 'Sözcük grupları',
    goToTargeting: 'Gösterim koşulları',
    'group-adm-send-md-error': 'Gruplar yeniden moderasyona gönderilemedi',
    'group-adm-send-md-success': 'Gruplar yeniden moderasyona gönderildi',
    'group-archive-success': 'Seçilen tüm gruplar arşive eklendi',
    'group-archive-success-none': 'Gruplar arşive eklenemedi',
    'group-archive-success-some': {
        one: '{count} / {allCount} grup arşive eklendi.',
        some: '{count} / {allCount} grup arşive eklendi.',
        many: '{count} / {allCount} grup arşive eklendi.',
        none: '{count} / {allCount} grup arşive eklendi.'
    },
    'group-can-not-be-accept-moderation-additions': 'İşlem için uygun grup yok',
    'group-can-not-be-adm-send-md': 'İşlem için uygun grup yok',
    'group-can-not-be-moderate-accept': 'İşlem için uygun grup yok',
    'group-can-not-be-remoderate-additions': 'İşlem için uygun grup yok',
    'group-can-not-be-send-moderate': 'İşlem için uygun grup yok',
    'group-can-not-regions-transform': 'İşlem için uygun grup yok',
    'group-can-not-sendBK': 'İşlem için uygun grup yok',
    'group-delete-success': 'Gruplar silindi',
    'group-delete-success-none': 'Gruplar silinemedi',
    'group-delete-success-some': {
        one: '{count} / {allCount} grup silindi',
        some: '{count} / {allCount} grup silindi',
        many: '{count} / {allCount} grup silindi',
        none: '{count} / {allCount} grup silindi'
    },
    'group-exceeded-max-size': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-accept-moderation-additions': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-adm-send-md': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-copy': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-delete': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-moderate-accept': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-regions-transform': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-remoderate-additions': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-send-moderate': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-exceeded-max-size-to-sendBK': "Seçilen grup sayısı 1000'den az olmalıdır",
    'group-moderate-accept-banners-additions-error':
        'Gruplar, netleştirmelerin moderasyonunu onaylamak için gönderilemedi',
    'group-moderate-accept-banners-additions-success':
        'Gruplar, netleştirmelerin moderasyonunu onaylamak için gönderildi',
    'group-moderate-accept-banners-additions-success-some': {
        one: '{count} / {allCount} grup, netleştirmelerin moderasyonunu onaylamak için gönderildi',
        some: '{count} / {allCount} grup, netleştirmelerin moderasyonunu onaylamak için gönderildi',
        many: '{count} / {allCount} grup, netleştirmelerin moderasyonunu onaylamak için gönderildi',
        none: '{count} / {allCount} grup, netleştirmelerin moderasyonunu onaylamak için gönderildi'
    },
    'group-moderate-accept-error': 'Gruplar, moderasyonu onaylamak için gönderilemedi',
    'group-moderate-accept-success': 'Gruplar, moderasyonu onaylamak için gönderildi',
    'group-remoderate-banners-additions-error': 'Gruplar, netleştirmelerin moderasyonuna gönderilemedi',
    'group-remoderate-banners-additions-success': 'Gruplar, netleştirmelerin moderasyonuna gönderildi',
    'group-remoderate-banners-additions-success-some': {
        one: '{count} / {allCount} grup, netleştirmelerin moderasyonuna gönderildi',
        some: '{count} / {allCount} grup, netleştirmelerin moderasyonuna gönderildi',
        many: '{count} / {allCount} grup, netleştirmelerin moderasyonuna gönderildi',
        none: '{count} / {allCount} grup, netleştirmelerin moderasyonuna gönderildi'
    },
    'group-resume-success': 'Seçilen tüm gruplar için gösterimler devam ediyor',
    'group-resume-success-none': 'Grup gösterimleri devam edemiyor',
    'group-resume-success-some': {
        one: '{count} / {allCount} grup için gösterimler devam ediyor.',
        some: '{count} / {allCount} grup için gösterimler devam ediyor.',
        many: '{count} / {allCount} grup için gösterimler devam ediyor.',
        none: '{count} / {allCount} grup için gösterimler devam ediyor.'
    },
    'group-send-moderate-error': 'Gruplar moderasyona gönderilemedi',
    'group-send-moderate-success': 'Gruplar moderasyona gönderildi',
    'group-send-moderate-success-some': {
        one: '{count} / {allCount} grup moderasyonuna gönderildi',
        some: '{count} / {allCount} grup moderasyonuna gönderildi',
        many: '{count} / {allCount} grup moderasyonuna gönderildi',
        none: '{count} / {allCount} grup moderasyonuna gönderildi'
    },
    'group-sendBK-error': "Gruplar Hareketli Banner'a gönderilemedi",
    'group-sendBK-success': "Gruplar Hareketli Banner'a gönderildi",
    'group-single-adm-send-md-error': '{name} grubu yeniden moderasyona gönderilemedi',
    'group-single-adm-send-md-success': '{name} grubu yeniden moderasyona gönderildi',
    'group-single-delete-error': '{name} grubu silinemedi',
    'group-single-delete-success': '{name} grubu silindi',
    'group-single-moderate-accept-banners-additions-error':
        '{name} grubu netleştirmelerin moderasyonunu onaylamak için gönderilemedi',
    'group-single-moderate-accept-banners-additions-success':
        '{name} grubu netleştirmelerin moderasyonunu onaylamak için gönderildi',
    'group-single-moderate-accept-error': '{name} grubu moderasyon onayına gönderilemedi',
    'group-single-moderate-accept-success': '{name} grubu moderasyon onayına gönderildi',
    'group-single-remoderate-banners-additions-error':
        '{name} grubu, netleştirmelerin yeniden moderasyonuna gönderilemedi',
    'group-single-remoderate-banners-additions-success':
        '{name} grubu, netleştirmelerin yeniden moderasyonuna gönderildi',
    'group-single-send-moderate-error': '{name} grubu moderasyona gönderilemedi',
    'group-single-send-moderate-success': '{name} grubu moderasyona gönderildi',
    'group-single-sendBK-error': "{name} grubu Hareketli Banner'a gönderilemedi",
    'group-single-sendBK-success': "{name} grubu Hareketli Banner'a gönderildi",
    'group-stop-success': 'Seçilen tüm gruplar durduruldu',
    'group-stop-success-none': 'Grup gösterimleri durdurulamadı',
    'group-stop-success-some': {
        one: '{count} / {allCount} grup durduruldu.',
        some: '{count} / {allCount} grup durduruldu.',
        many: '{count} / {allCount} grup durduruldu.',
        none: '{count} / {allCount} grup durduruldu.'
    },
    'group-unarchive-success': 'Seçilen tüm gruplar arşivden çıkarıldı',
    'group-unarchive-success-none': 'Gruplar arşivden çıkarılamadı',
    'group-unarchive-success-some': {
        one: '{count} / {allCount} grup arşivden çıkarıldı.',
        some: '{count} / {allCount} grup arşivden çıkarıldı.',
        many: '{count} / {allCount} grup arşivden çıkarıldı.',
        none: '{count} / {allCount} grup arşivden çıkarıldı.'
    },
    'groups-universal-with-yt-limit':
        'Sadece ilk {count} grup seçildi; tek seferde daha fazlası değiştirilemez. Filtre uygulayarak listedeki grup sayısını azaltabilirsiniz.',
    'internal-tool-title': 'Dahili araçlar',
    moderate: 'Kontrole gönder',
    moderateAccept: 'Moderasyonu onayla',
    moderateAcceptBannersAdditions: 'Moderasyon: Netleştirmeleri kabul et',
    'no-editable': 'Düzenleme geçersiz',
    'one-banners-not-saved': 'Reklam kaydedilmedi',
    'one-banners-saved': 'Reklam kaydedildi',
    'open-search-and-replace-inspector': 'Bul ve değiştir',
    openMinusPhraseSelector: 'Negatif anahtar sözcük gruplarının dizilerini ayarla',
    openMinusPhraseSelectorDisabledInfo: 'Sadece "Metin-Grafik Reklamlar" ve "Arama banner\'ı" gruplarını seçin',
    openMinusPhraseSelectorNoRights: 'Negatif anahtar sözcük grubu dizilerinin ayarlanması için yetki yok',
    openMinusPhraseSelectorOverMaxInfo: 'Seçilen grup sayısı {count} değerinin altında olmalı',
    openPhrasesSelectorWizard: 'Sözcük gruplarını seç',
    payByCash: 'Bakiye ekle',
    'phrases-delete-success': 'Sözcük grupları silindi',
    'phrases-disable-success': 'Sözcük grupları durduruldu',
    'phrases-enable-success': 'Sözcük grupları etkinleştirildi',
    'phrases-set-common-price-error-all': 'Teklif belirtilemedi',
    'phrases-set-common-price-error-one': 'Teklif belirtilemedi',
    'phrases-set-common-price-success-all': 'Teklif belirtildi',
    'phrases-set-common-price-success-one': 'Teklif belirtildi',
    'phrases-set-common-price-warning': {
        one: '{count} / {totalCount} sözcük grubu için teklif belirtildi',
        some: '{count} / {totalCount} sözcük grubu için teklif belirtildi',
        many: '{count} / {totalCount} sözcük grubu için teklif belirtildi',
        none: '{count} / {totalCount} sözcük grubu için teklif belirtildi'
    },
    'phrases-universal-with-yt-limit':
        'Sadece ilk {count} sözcük grubu seçildi; tek seferde daha fazlası değiştirilemez. Filtre uygulayarak listedeki sözcük grubu sayısını azaltabilirsiniz.',
    'phrases-wizard-data-set-none': 'Teklifler hiçbir sözcük grubuna uygulanmadı',
    'phrases-wizard-data-set-success':
        'Yeni teklifler {setCount} / {phrasesCount} sözcük grubu için belirtildi. Aktivasyon yaklaşık 30 dakika sürer.',
    'phrases-wizard-data-set-success-with-yt-limit':
        'Yeni teklifler {setCount} sözcük grubu için belirtildi. Aktivasyon yaklaşık 30 dakika sürer. Teknik sınırlama nedeniyle diğer sözcük grupları seçime girmedi. Bu sözcük gruplarını filtreleyin ve teklif belirleme işlemini tekrarlayın.',
    pricesWizard: 'Teklif sihirbazı',
    'regions-transform': 'Gösterim bölgelerini ayarla',
    'regions-transform-access-error': 'Gösterim bölgesi ayarlarını düzenleme yetkiniz yok',
    remoderate: 'Tekrar kontrole gönder',
    'remoderate-success': 'Kampanyalar yeniden moderasyona gönderildi',
    remoderateBannersAdditions: 'Netleştirmelerin yeniden moderasyonu',
    removeFromFavorites: 'En önemlilerden sil',
    resume: 'Gösterimleri sürdür',
    'resume-retargetings': 'Etkinleştir',
    'resume-success': 'Kampanyalar için gösterimler yeniden başlatıldı',
    resumeBanner: 'Gösterimleri sürdür',
    'retargetings-delete-error-all': 'Koşullar silinemedi',
    'retargetings-delete-error-one': 'Koşul silinemedi',
    'retargetings-delete-success-all': 'Seçilen tüm koşullar silindi',
    'retargetings-delete-success-one': 'Koşul silindi',
    'retargetings-delete-warning-some': {
        one: '{count} / {totalCount} koşul silindi',
        some: '{count} / {totalCount} koşul silindi',
        many: '{count} / {totalCount} koşul silindi',
        none: '{count} / {totalCount} koşul silindi'
    },
    'retargetings-resume-error-all': 'Koşullar yeniden başlatılamadı',
    'retargetings-resume-error-one': 'Koşul yeniden başlatılamadı',
    'retargetings-resume-success-all': 'Seçilen tüm koşullar yeniden başlatıldı',
    'retargetings-resume-success-one': 'Koşul yeniden başlatıldı',
    'retargetings-resume-warning-some': {
        one: '{count} / {totalCount} koşul yeniden başlatıldı',
        some: '{count} / {totalCount} koşul yeniden başlatıldı',
        many: '{count} / {totalCount} koşul yeniden başlatıldı',
        none: '{count} / {totalCount} koşul yeniden başlatıldı'
    },
    'retargetings-set-common-price-error-all': 'Teklif belirtilemedi',
    'retargetings-set-common-price-error-one': 'Teklif belirtilemedi',
    'retargetings-set-common-price-success-all': 'Teklif belirtildi',
    'retargetings-set-common-price-success-one': 'Teklif belirtildi',
    'retargetings-set-common-price-warning-some': {
        one: 'Teklif, toplam {totalCount} koşuldan {count} adedi için belirtildi',
        some: 'Teklif, {totalCount} koşuldan {count} adedi için belirtildi',
        many: 'Teklif, {totalCount} koşuldan {count} adedi için belirtildi',
        none: 'Teklif, {totalCount} koşuldan {count} adedi için belirtildi'
    },
    'retargetings-suspend-error-all': 'Koşullar durdurulamadı',
    'retargetings-suspend-error-one': 'Koşul durdurulamadı',
    'retargetings-suspend-success-all': 'Seçilen tüm koşullar durduruldu',
    'retargetings-suspend-success-one': 'Koşul durduruldu',
    'retargetings-suspend-warning-some': {
        one: '{count} / {totalCount} koşul durduruldu',
        some: '{count} / {totalCount} koşul durduruldu',
        many: '{count} / {totalCount} koşul durduruldu',
        none: '{count} / {totalCount} koşul durduruldu'
    },
    'retargetings-universal-with-yt-limit':
        'Sadece ilk {count} gösterim kuralı seçildi; tek seferde daha fazlası değiştirilemez. Filtre uygulayarak listedeki gösterim kurallarının sayısını azaltabilirsiniz.',
    sendBK: "Hareketli Banner'a gönder",
    'sendBK-confirm-groups': "Seçilen grupları Hareketli Banner'a göndermek istediğinize emin misiniz?",
    'sendBK-confirm-single-groups': "{name} grubunu Hareketli Banner'a göndermek istediğinize emin misiniz?",
    sendModerate: 'Kontrole gönder',
    sendModerateByClient: 'Kontrole gönder',
    'set-common-price': 'Ortak teklif belirt',
    'status-title': 'Durum',
    stop: 'Durdur',
    'stop-success': 'Kampanyalar durduruldu',
    stopBanner: 'Durdur',
    'suspend-retargetings': 'Durdur',
    'tool-title': 'Araçlar',
    unarchive: 'Arşivden çıkar',
    'unarchive-success': 'Kampanyalar arşivden çıkarıldı',
    unarchiveBanner: 'Arşivden çıkar',
    'unknown-error': 'Bilinmeyen hata',
    'users-profile-universal-with-yt-limit':
        'Tek seferde değiştirilebilecek maksimum rakam bu olduğundan sadece ilk {count} gösterim kuralı seçildi. Listeyi daraltmak için filtre kullanabilirsiniz.'
};
